import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';
import PropTypes from 'prop-types';

export const banUser = ({ id }) => {
  return axios.post(`/users/${id}/ban`);
};

banUser.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useBanUser = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (bannedUser) => {
      await queryClient.cancelQueries('activeUsers');

      const previousUsers = queryClient.getQueryData('activeUsers');

      queryClient.setQueryData(
        'activeUsers',
        previousUsers?.filter((user) => user.id !== bannedUser.id)
      );

      return { previousUsers };
    },
    onError: (_, __, context) => {
      if (context?.previousUsers) {
        queryClient.setQueryData('activeUsers', context.previousUsers);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('activeUsers');
      addNotification({
        type: 'success',
        title: 'User Banned',
      });
    },
    ...config,
    mutationFn: banUser,
  });
};
